import classNames from "classnames";
import scss from "@/styles/pages/pricing/hero.module.scss";

export const wrapper = classNames(
    // Mobile
    "mobile:flex-col",
    "mobile:justify-center",
    // Tablet
    "tablet:flex-row",
    "tablet:justify-left",
    // All
    "flex",
    "items-center",
    "pt-10",
    "pb-10"
);
export const image = classNames(
    // Mobile
    "mobile:w-full",
    "mobile:h-auto",
    // Tablet
    "tablet:w-1/2",
    // "tablet:-ml-96",
    scss["image"],
    // All
    "max-w-screen-md"
);

export const content = classNames(
    // mobile
    "mobile:w-full",
    "mobile:text-center",
    // Tablet
    "tablet:w-auto",
    "tablet:text-left",
    // ALl
    "p-6"
);

export const subHeading = classNames(
    // Mobile
    "mobile:w-auto",
    "mobile:text-base",
    "mobile:mb-6",
    "mobile:mt-6",
    // Tablet
    "tablet:w-96",
    "tablet:text-xl",
    // All
    "mt-10",
    "mb-10"
);
export const button = classNames(
    // Mobile
    "mobile:m-auto",
    "mobile:text-xl",
    "mobile:p-6",
    // Tablet
    "tablet:m-0",
    "tablet:text-xl",
    // All
    "flex",
    "items-center",
    "justify-start",
    "w-auto",
    "h-10",
    "bg-secondary",
    "text-white",
    "rounded-xl",
    "p-4"
);
export const buttonIcon = classNames("w-6", "mr-3");
